import { z } from 'zod';
export const entityTypeSchema = z.enum(['lead', 'contact', 'company']);
export const createTagSchema = z.object({
    name: z.string().trim().min(1).max(60),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/)
        .default('#454A54'),
    entityTypes: z.array(entityTypeSchema).min(1).default(['lead', 'contact', 'company']),
});
export const updateTagSchema = createTagSchema.partial();
export const tagResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    color: z.string(),
    entityTypes: z.array(entityTypeSchema),
});
const oneArc = (shape) => z.object(shape).refine((v) => [v.leadId, v.contactId, v.companyId].filter(Boolean).length === 1, {
    message: 'Exactly one of leadId, contactId or companyId is required',
});
export const attachTagSchema = oneArc({
    tagId: z.string().uuid(),
    leadId: z.string().uuid().optional(),
    contactId: z.string().uuid().optional(),
    companyId: z.string().uuid().optional(),
});
export const detachTagSchema = attachTagSchema;
//# sourceMappingURL=tags.js.map